module.exports = __webpack_public_path__ + "assets/flyt-icons_private-pin.6829b510.svg";